import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useShowsBeta } from './betaHooks';
import { type BetaPageId, betaPages } from './betaPages';

export const OpenChosenVersion = ({
  page,
  children,
}: {
  page: BetaPageId;
  children: ReactNode;
}) => {
  const showsBeta = useShowsBeta(page);
  const { switching } = betaPages[page];

  if (!showsBeta) return children;
  if (switching.kind !== 'route') return children;

  return <Navigate to={switching.betaPath} replace />;
};
